export const content = {        
    page: {        
        barrel: {
            //synthesized values, possibly compute on the fly?
            owner: "JOHN DOE",
            isConsumed: false,
            referenceNumber: "12RASAUT000000001",
            totalFuel: {value: 100.00, units: "gallons"},
            totalTbds: {value: 317.60, units: "tbds"},
            miningLocation: "XYZ quarry, Utah",
            miningDate: "1st March 2025",
            processingLocation: "RASA XYZ, Utah",
            processingDate: "3rd March 2025"
        },
        mining: {         
            tbdsUsed: {value: 20.00, units: "tbds"},
        },
        transport: {
            tbdsUsed: {value: 20.00, units: "tbds"},
            distance: {value: 200.00, units: "miles"},
            ore: {value: 2000.00, units: "lbs"},
            fuel: {value: 85.04, units: "gallons"}
        },
        crushing: {
            tbdsUsed: {value: 20.00, units: "tbds"},
            ore: {value: 4000.00, units: "lbs", type: "ore"},
            crushedOre: {value: 3700.00, units: "lbs", type: "ore"},
            fuel: {value: 170.00, units: "gallons", type: "fuel"}
        },
        psa: {
            crushedOre: {value: 3700.00, units: "lbs", type: "ore"},
            diesel: {value: 200.00, units: "lbs"},
            bitumen: {value: 500.00, units: "lbs"},
            sand: {value: 3000.00, units: "lbs"},
            fuel: {value: 170.00, units: "gallons"},            
            tbdsUsed: {value: 20.00, units: "tbds"}, 
        }
    }   
}